import React from 'lib/react';
import {
  EVGrid,
  EVPaper,
  EVSkeleton,
} from 'lib/components';
import PropTypes from 'prop-types';

function ReportDetailsPageLoader({ isMobile, classes }) {
  return (
    <EVPaper square={isMobile} className={classes.orderDetailsPaper}>
      <EVGrid container className={classes.orderDetailsContainer}>
        <EVGrid className={classes.orderDetailsHeaderContainer}>
          {!isMobile && (
            <EVSkeleton className={classes.skeletonLoader} width={isMobile ? '100%' : 220} height={isMobile ? 36 : 46} animation="wave" />
          )}

          <EVGrid container className={classes.orderDetailsAddress}>
            <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 80 : 57} animation="wave" />
          </EVGrid>
          <EVGrid className={classes.orderDetailsFiles}>
            <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 27} animation="wave" />
          </EVGrid>
        </EVGrid>
        <EVGrid className={classes.orderDetailsContent}>
          <EVGrid container>
            <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 400} animation="wave" />
          </EVGrid>
          <EVGrid className={classes.orderDetailsListItem} style={{ width: '100%' }}>
            <EVGrid container>
              <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 27} animation="wave" />
            </EVGrid>
            <EVGrid container>
              <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 27} animation="wave" />
            </EVGrid>
            <EVGrid container>
              <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 27} animation="wave" />
            </EVGrid>
            <EVGrid container>
              <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 27} animation="wave" />
            </EVGrid>
            <EVGrid container>
              <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 27} animation="wave" />
            </EVGrid>
            <EVGrid container>
              <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 27} animation="wave" />
            </EVGrid>
            <EVGrid container>
              <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 27} animation="wave" />
            </EVGrid>
            <EVGrid container>
              <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 27} animation="wave" />
            </EVGrid>
            <EVGrid container>
              <EVSkeleton className={classes.skeletonLoader} width="100%" height={isMobile ? 36 : 27} animation="wave" />
            </EVGrid>
          </EVGrid>
        </EVGrid>

      </EVGrid>

    </EVPaper>
  );
}

ReportDetailsPageLoader.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  classes: PropTypes.shape().isRequired,
};

export default ReportDetailsPageLoader;
